// extracted by mini-css-extract-plugin
export var avatar = "_rq-3";
export var avatarContainer = "_rq-2";
export var avatarSpacer = "_rq-5";
export var avatarSpacerContainer = "_rq-4";
export var avatarStackContainer = "_rq-1";
export var bubble = "_rq-0";
export var remainderBubble = "_rq-6";